export const fetchTokenData = async (address) => {
  try {
    // Added timestamp cache-busting to bypass CDN delay
    const response = await fetch(`https://api.dexscreener.com/latest/dex/tokens/${address}?t=${Date.now()}`, {
      cache: 'no-store'
    });
    
    if (!response.ok) throw new Error('Network response was not ok');
    
    const data = await response.json();
    
    if (!data.pairs || data.pairs.length === 0) {
      throw new Error('Token not found on DexScreener');
    }

    const solPairs = data.pairs.filter(pair => pair.chainId === 'solana');
    if (solPairs.length === 0) {
      throw new Error('No Solana liquidity pairs found');
    }

    // Sort by liquidity to get the most active pair
    const primaryPair = solPairs.sort((a, b) => (b.liquidity?.usd || 0) - (a.liquidity?.usd || 0))[0];

    return {
      name: primaryPair.baseToken.name,
      symbol: primaryPair.baseToken.symbol,
      price: parseFloat(primaryPair.priceUsd),
      pairAddress: primaryPair.pairAddress,
      baseTokenAddress: primaryPair.baseToken.address,
      dexUrl: primaryPair.url,
      liquidity: primaryPair.liquidity?.usd || 0,
      volume24h: primaryPair.volume?.h24 || 0
    };
  } catch (error) {
    console.error('Error fetching token data:', error);
    throw error;
  }
};

export const fetchOHLCV = async (pairAddress, timeframe) => {
  try {
    let tf, aggr;
    
    switch(timeframe) {
      case '1m': tf = 'minute'; aggr = 1; break;
      case '5m': tf = 'minute'; aggr = 5; break;
      case '15m': tf = 'minute'; aggr = 15; break;
      case '1h': tf = 'hour'; aggr = 1; break;
      case '4h': tf = 'hour'; aggr = 4; break;
      default: tf = 'minute'; aggr = 5;
    }

    // GeckoTerminal Free Public API
    const url = `https://api.geckoterminal.com/api/v2/networks/solana/pools/${pairAddress}/ohlcv/${tf}?aggregate=${aggr}&limit=100`;
    
    const response = await fetch(url);
    if (!response.ok) throw new Error('Failed to fetch historical OHLCV data');
    
    const data = await response.json();
    if (!data.data || !data.data.attributes || !data.data.attributes.ohlcv_list) {
      return [];
    }

    // Gecko returns newest first. We need oldest first for math.
    // [timestamp, open, high, low, close, volume]
    return data.data.attributes.ohlcv_list.map(candle => ({
      time: candle[0],
      open: parseFloat(candle[1]),
      high: parseFloat(candle[2]),
      low: parseFloat(candle[3]),
      close: parseFloat(candle[4]),
      volume: parseFloat(candle[5])
    })).reverse();
  } catch (error) {
    console.error('Error fetching OHLCV:', error);
    return [];
  }
};